import { darken } from "@mui/material";
import { RevivnDatabaseDataGrid } from "components/DataGrid/RevivnDatabaseDataGrid";
import { columns } from "components/Orders/columns";
import useCurrentUser from "hooks/useCurrentUser";
import { DatabaseDataGridSavedFilterTabs } from "components/DataGrid/components/DatabaseDataGridSavedFilterTabs";
import { DateTime } from "luxon";
import { FullPagePaperLayout } from "pages/Layouts/FullPagePaperLayout";
import { PageBreadcrumbs, PageTitle } from "./Layouts/components/PageTitleContainer";
import { PagePaperPreamble } from "pages/Layouts/components/PagePaperPreamble";

const getDateString = (date: Date) => {
  return date.toISOString().split("T")[0];
};

export const getTomorrowAt10AMISO = (timezone: string | null) => {
  return DateTime.now()
    .setZone(timezone || "America/Los_Angeles")
    .plus({ days: 1 })
    .set({ hour: 10, minute: 0, second: 0, millisecond: 0 })
    .toISO()
    ?.split(".")?.[0];
};

export const NCPOrdersPage = () => {
  const tenDaysAgo = new Date();
  tenDaysAgo.setDate(tenDaysAgo.getDate() - 10);
  const { user } = useCurrentUser();
  const url = `fulfillment_ncp_orders?filter[]=ordered_at,after,${getDateString(tenDaysAgo)}`;
  if (!user) return null;

  const tomorrowAt10AM = getTomorrowAt10AMISO(user.warehouseTimezone);

  return (
    <FullPagePaperLayout>
      <PageBreadcrumbs links={[{ label: "Fulfillment" }]} />
      <PageTitle>NCP Orders</PageTitle>
      <PagePaperPreamble>
        <DatabaseDataGridSavedFilterTabs
          url={url}
          savedFilters={[
            {
              label: "Due Today",
              filters: `ship_by,on_or_before,${tomorrowAt10AM} AND warehouse,is,${user.warehouseName} AND state,not,packed`,
            },
            {
              label: "Needs Inventory",
              filters: "state,is,created AND inventory_item,is_empty",
            },
            {
              label: "Needs Valid Address",
              filters: "address_verified_at,is_empty",
            },
            {
              label: "Due Later",
              filters: `ship_by,after,${tomorrowAt10AM} AND warehouse,is,${user.warehouseName} AND state,not,packed`,
            },
            {
              label: "All Orders",
              filters: "__any__",
            },
          ]}
        />
      </PagePaperPreamble>

      <RevivnDatabaseDataGrid
        url={url}
        syncStateWithSearchParams
        remoteCsvExport={true}
        persistSettingsKey="ordersPage"
        columns={columns}
        getRowClassName={(params) => (params.row.state != "packed" && params.row.priority > 0 ? "high-priority" : "")}
        sx={{
          "& .high-priority": {
            backgroundColor: "#ffcccc",
            "&:hover": {
              backgroundColor: darken("#ffcccc", 0.1),
            },
          },
        }}
      />
    </FullPagePaperLayout>
  );
};
